<template>
  <div class="form-table">
    <!-- 表单 -->
    <el-form ref="elForm" :model="formData" inline label-width="auto">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="formData.name" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-select v-model="formData.sex" placeholder="请选择" clearable>
          <el-option label="男" value="0"></el-option>
          <el-option label="女" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" @click="handleSubmitForm">查询</el-button>
        <el-button :loading="loading" @click="handleResetForm">重置</el-button>
      </el-form-item>

      <div class="form-buttons">
        <el-button type="primary" :loading="loading" @click="handleAdd">添加</el-button>
      </div>
    </el-form>

    <!-- 表格 -->
    <el-table v-loading="loading" class="table" :data="tableData" height="100%" border stripe>
      <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
      <el-table-column prop="name" label="姓名" align="center"></el-table-column>
      <el-table-column prop="sex" label="性别" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.sex == 0" type="primary">男</el-tag>
          <el-tag v-else type="danger">女</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="birthday" label="生日" align="center">
        <template slot-scope="scope">
          {{ $moment(scope.row.birthday).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column prop="money" label="金额" align="right">
        <template slot-scope="scope">￥{{ scope.row.money.toLocaleString() }}</template>
      </el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleRowEdit(scope)">
            编辑
          </el-button>
          <el-popconfirm title="确认删除？" @confirm="handleRowDel(scope)">
            <el-button
              class="ml10"
              slot="reference"
              type="text"
              size="small"
              :style="{ color: '#f00' }"
            >
              删除
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="table-page">
      <el-pagination
        :current-page="pageData.pageNo"
        :page-size="pageData.pageSize"
        :total="total"
        :page-sizes="[20, 50, 100, 200]"
        :disabled="loading"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <!-- 弹窗 -->
    <form-dlg v-model="showDlg" :data="currentRowData" @submit-form="dlgSubForm"></form-dlg>
  </div>
</template>

<script>
import FormDlg from './components/form-dlg.vue'
import { mockGetTableData } from '@/mock/demo.js'

export default {
  name: 'form-table',
  components: {
    FormDlg,
  },
  props: {},
  data() {
    return {
      loading: false,
      showDlg: false,
      formData: {},
      tableData: [],
      currentRowData: {},
      pageData: {
        pageNo: 1,
        pageSize: 50,
      },
      total: 0,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getTableData()
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    // 表单查询
    handleSubmitForm() {
      this.getTableData(1)
    },

    // 重置表单
    handleResetForm() {
      this.$refs.elForm.resetFields()
      this.getTableData(1)
    },

    // 添加
    handleAdd() {
      this.currentRowData = {}
      this.showDlg = true
    },

    // 表格行-编辑
    handleRowEdit(data) {
      const { row } = data

      this.currentRowData = { ...row }
      this.showDlg = true
    },

    // 表格行-删除
    handleRowDel(data) {
      const { row } = data

      this.currentRowData = { ...row }
      this.$message.success('删除成功')

      this.getTableData()
    },

    // 分页-改变页码大小
    handleSizeChange(pageSize) {
      this.pageData.pageSize = pageSize

      this.getTableData(1)
    },

    // 分页-改变当前页
    handleCurrentChange(pageNo) {
      this.getTableData(pageNo)
    },

    // 弹窗表单提交
    dlgSubForm() {
      if (this.currentRowData.id || this.currentRowData.id === 0) {
        this.getTableData()
      } else {
        this.getTableData(1)
      }
    },

    // 获取表格数据
    getTableData(pageNo) {
      this.loading = true
      pageNo && (this.pageData.pageNo = pageNo)

      mockGetTableData({
        ...this.formData,
        ...this.pageData,
      }).then(res => {
        const { data = [], total } = res || {}

        this.tableData = data
        this.total = total
        this.loading = false
      })
    },
  },
}
</script>

<style lang="less" scoped></style>
